module.exports = __webpack_public_path__ + "static/media/yellow-light.f2403553.svg";